import { Component, OnInit, Input } from '@angular/core';
import {FormControl, FormArray, FormGroupDirective, NgForm, Validators, FormGroup, FormBuilder} from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { FirstStageService } from '../../service/first-stage.service';
import {Router, ActivatedRoute, NavigationEnd} from '@angular/router';
import { Observable, Subscription, timer } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';
import {MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatDatepicker} from '@angular/material/datepicker';
import { Title } from '@angular/platform-browser';


@Component({
  selector: 'app-candidate-application-form',
  templateUrl: './candidate-application-form.component.html'
})
export class CandidateApplicationFormComponent implements OnInit {
    activePage: any = '1';
    companyId: any;
    disabled = false;
    currentWork = false;
    checked = true;
    showAddMoreBtn = false;
    date: any;
    apiDate: any;
    a: any;
    b: any;
    startDate;
    endDate;
    showHidePopup = false;
    private timer: Observable<any>;
    private subscription: Subscription;
    submitBtn = true;
    resubmitBtn = false;
    currentDate = new Date();
    minDate = new Date(1900, 0, 1);
    maxDate = new Date(2060, 0, 1);
    birtdmodel = Date;
    events: string[] = [];
    currentLang = '';
    educationAddMore = false;
    languageAddMore = false;
    certificateAddMore = false;
    experienceAddMore = false;
    somethingChanged: any;
    showWorkHistory = false;
    showCertificate = false;
    forthActive = false;
    forthStep = false;
    updateDate: any;
    updateId = '-1';


    pop: any;
    hostName: string;
    interestsArray = [] as string[];


  employeeForm: FormGroup;
  interests: FormGroup;

  educationLevels: any [] = [
    {
      value: 'secondary',
      viewValue: 'secondaryEducation'
    },
    {
      value: 'bachelor',
      viewValue: 'bachelorDegree'
    },
    {
      value: 'master',
      viewValue: 'masterDegree'
    },
    {
      value: 'phd',
      viewValue: 'phd'
    }
  ];
  areasOfInterests: any [] = [
    {
      viewValue: 'areasOfInterest1'
    },
    {
      viewValue: 'areasOfInterest2'
    },
    {
      viewValue: 'areasOfInterest3'
    },
    {
      viewValue: 'areasOfInterest4'
    },
    {
      viewValue: 'areasOfInterest5'
    },
    {
      viewValue: 'areasOfInterest6'
    },
    {
      viewValue: 'areasOfInterest7'
    },
    {
      viewValue: 'areasOfInterest8'
    },
    {
      viewValue: 'areasOfInterest9'
    },
    {
      viewValue: 'areasOfInterest10'
    },
    {
      viewValue: 'areasOfInterest11'
    },
    {
      viewValue: 'areasOfInterest12'
    },
    {
      viewValue: 'areasOfInterest13'
    }
  ];
  constructor(private fb: FormBuilder,
              private firstStageService: FirstStageService,
              private http: HttpClient,
              private router: Router,
              private route: ActivatedRoute,
              public translateService: TranslateService,
              private titleService: Title) {
    this.route.params.subscribe(params => {
        if (params.id) {
          localStorage.setItem('id', params.id);
        }
    });
    this.companyId = localStorage.getItem('companyId');
    this.currentLang = localStorage.getItem('lang');
  }

  formErrors = {};
  validationMessages = {
    firstName: {
      required: 'First name is required',
    },
    lastName: {
      required: 'Last name is required',
    },
    middleInitial: {
      required: 'Middle name is required',
    },
    gender: {
      required: 'Gender is required',
    },
    birthdate: {
      required: 'Birth date is required',
    },
    cellPhone: {
      required: 'Mobile phone is required',
      pattern: 'Please provide a valid phone number',
    },
    email: {
      required: 'Email is required',
      pattern: 'Please provide a valid email address',
    },
    SocialWebsite: {
      required: 'Social website is required'
    },
    BusinessDomain: {
      required: 'Area of Interest is required',
    },
    Internship: {
      required: 'Internship is required',
    },
    ValueBring: {
      required: 'Motivation message is required',
    },
    phone: {
      required: 'Home phone is required',
      pattern: 'Please provide a valid phone number',
    },
    ExpectedSalary: {
      required: 'Salary is required',
    },
  };

  public getLanguageJSON(): Observable<any> {
    return this.http.get('/assets/language.json');
}

  ngOnInit() {
    this.employeeForm = this.fb.group({
        requisitionId: '',
        candidate: this.fb.group({
            firstName: ['', Validators.required],
            lastName: ['', Validators.required],
            middleInitial: ['', Validators.required],
            gender:  ['', Validators.required],
            originalBirthDate: ['', Validators.required],
            birthDateViewValue: [''],
            birthdate: [''],
            cellPhone: ['', Validators.compose([
              Validators.required,
              Validators.pattern(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/)
            ])],
            phone: ['', Validators.compose([
              Validators.pattern(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/)
            ])],
            email: ['', Validators.compose([
              Validators.required,
              // tslint:disable-next-line: max-line-length
              Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
            ])],
            SocialWebsite: ['', Validators.required],
            SocialWebsiteCheckbox: [false],
            Armenian: ['', Validators.required],
            Russian: ['', Validators.required],
            English: ['', Validators.required],
            MSOffice: [''],
            Armsoft: [''],
            OtherComputerSkills: [''],
            ExpectedSalary: ['', Validators.compose([
                Validators.required,
                Validators.pattern(/^[0-9]*$/)
              ])],
            BusinessDomain: ['', Validators.required],
            ValueBring: [''],
            OtherLanguageSkills: [''],
            status: '5022'
        }),
        otherLanguageSkills: this.fb.array([
          this.addLanguageFormgroup()
        ]),
        education: this.fb.array([
            this.addEducationFormGroup()
        ]),
        certificate: this.fb.array([
            this.addCertificateFormGroup()
        ]),
        workhistory: this.fb.array([
            this.addExperienceFormGroup()
        ]),
        interests: this.fb.group({
            areasOfInterest1: [''],
            areasOfInterest2: [''],
            areasOfInterest3: [''],
            areasOfInterest4: [''],
            areasOfInterest5: [''],
            areasOfInterest6: [''],
            areasOfInterest7: [''],
            areasOfInterest8: [''],
            areasOfInterest9: [''],
            areasOfInterest10: [''],
            areasOfInterest11: [''],
            areasOfInterest12: [''],
            areasOfInterest13: [''],
        }),
    });


    this.getPageUpdateDate();

    this.translateService.get('form1BrowserName').subscribe(name => {
      this.titleService.setTitle(name);
    });

  }

  otherLanguages() {
    const pope = [] as string[];
    const otherLangArray  =  [...this.employeeForm.value.otherLanguageSkills];
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < otherLangArray.length; i++) {
        if (otherLangArray[i].a.length || otherLangArray[i].b.lenght) {
            pope.push(otherLangArray[i].a + ' ' + '(' + otherLangArray[i].b + ')');
        }
    }
    this.employeeForm.value.candidate = {...this.employeeForm.value.candidate, OtherLanguageSkills: pope.join(', ')};
  }

  getInterests(event: any, isChecked: boolean) {

    if (isChecked) {
        this.interestsArray.push(event);
    } else {
      const index = this.interestsArray.indexOf(event);
      this.interestsArray.splice(index, 1);
    }
  }

  onClickReview() {
      this.activePage = 5;
      this.forthActive = true;
      this.otherLanguages();
      this.getFormatedDates();
      this.employeeForm.value.candidate = {...this.employeeForm.value.candidate, BusinessDomain: this.interestsArray.join(', ')};
  }

  onClickForthStep() {
    this.activePage = 4;
    this.forthStep = true;
  }

  onChangeSocialWebsiteCheckboxValue() {
    if (this.employeeForm.get('candidate.SocialWebsiteCheckbox').value) {
      this.employeeForm.get('candidate.SocialWebsite').clearValidators();
      this.employeeForm.get('candidate.SocialWebsite').reset('');
    } else {
      this.employeeForm.get('candidate.SocialWebsite').setValidators(Validators.required);
    }
    this.employeeForm.get('candidate.SocialWebsite').updateValueAndValidity();
  }

  addEmployee() {
    delete this.employeeForm.value.candidate.SocialWebsiteCheckbox;
    this.otherLanguages();
    this.getFormatedDates();
    this.route.params.subscribe(params => {
        if (params.id) {
          this.employeeForm.value.requisitionId = params.id;
        }
    });
    const employeeFormStr = JSON.stringify(this.employeeForm.value);
    console.log(employeeFormStr);
    this.firstStageService.addEmployee(employeeFormStr).subscribe((result) => {
      if (result.Success) {
        this.router.navigate(['/success']);
      } else if (result.Message.length) {
        this.router.navigate(['/update']);
      } else {
        this.setTimer();
        this.submitBtn = false;
        this.resubmitBtn = true;
      }
    });
  }

  public setTimer() {
    this.showHidePopup = true;
    this.timer = timer(3000);
    this.subscription = this.timer.subscribe(() => {
        this.showHidePopup = false;
    });
  }

  addEducationFormGroup(): FormGroup {
    return this.fb.group({
      eduHistSchool: ['', Validators.required],
      eduHistDegree : ['', Validators.required],
      Profession: ['', Validators.required],
      originalEduHistFrom: ['', Validators.required],
      eduHistFromViewValue: [''],
      eduHistFrom: [''],
      originalEduHistTo: [''],
      eduHistToViewValue: [''],
      eduHistTo: [''],
      eduCheckbox: false
    });
  }

  addEducationButtonClick(): void {
    (this.employeeForm.get('education') as FormArray).push(this.addEducationFormGroup());
    this.educationAddMore = true;
  }

  removeEducationButtonClick(educationGroupIndex: number): void {
    (this.employeeForm.get('education') as FormArray).removeAt(educationGroupIndex);
    // @ts-ignore
    if (this.employeeForm.get('education').lenght > 1) {
        this.educationAddMore = true;
    } else {
        this.educationAddMore = false;
    }
  }

  addCertificateFormGroup(): FormGroup {
    return this.fb.group({
        certIssuingBody : [''],
        certName: [''],
        YearProvided: [''],
        originalYearProvided: [''],
        yearProvidedViewValue: ['']
    });
  }

  addCertificateButtonClick(): void {
    (this.employeeForm.get('certificate') as FormArray).push(this.addCertificateFormGroup());
    this.certificateAddMore = true;
  }

  removeCertificateButtonClick(certificateGroupIndex: number): void {
    (this.employeeForm.get('certificate') as FormArray).removeAt(certificateGroupIndex);
    // @ts-ignore
    if (this.employeeForm.get('certificate').lenght > 1) {
        this.certificateAddMore = true;
    } else {
        this.certificateAddMore = false;
    }
  }

  addExperienceFormGroup(): FormGroup {
    return this.fb.group({
      workHistCoName: [''],
      workHistJobTitle: [''],
      originalWorkHistFrom: [''],
      workHistFromViewValue: [''],
      workHistFrom: [''],
      originalWorkHistTo: [''],
      workHistToViewValue: [''],
      workHistTo: [''],
      workHistDesc: [''],
      workCheckbox: [false, Validators.required]
    });
  }

  addExperienceButtonClick(): void {
    (this.employeeForm.get('workhistory') as FormArray).push(this.addExperienceFormGroup());
    this.experienceAddMore = true;
  }

  removeExperienceButtonClick(experienceGroupIndex: number): void {
    (this.employeeForm.get('workhistory') as FormArray).removeAt(experienceGroupIndex);
    // @ts-ignore
    if (this.employeeForm.get('workhistory').lenght > 1) {
        this.experienceAddMore = true;
    } else {
        this.experienceAddMore = false;
    }
  }

  addLanguageFormgroup(): FormGroup {
    return this.fb.group({
        a: [''],
        b: ['']
    });
  }

  firstOtherLanguagesButtonClick() {
    this.showAddMoreBtn = true;
  }

  addOtherLanguagesButtonClick(): void {
    (this.employeeForm.get('otherLanguageSkills') as FormArray).push(this.addLanguageFormgroup());
    this.languageAddMore = true;
  }

  removeOtherLanguagesButtonClick(otherLanguageSkillsGroupIndex: number): void {
    (this.employeeForm.get('otherLanguageSkills') as FormArray).removeAt(otherLanguageSkillsGroupIndex);
    // @ts-ignore
    if (this.employeeForm.get('otherLanguageSkills').lenght > 1) {
        this.languageAddMore = true;
    } else {
        this.languageAddMore = false;
    }
  }

  logValidationErrors(group: FormGroup = this.employeeForm): void {
    Object.keys(group.controls).forEach((key: string) => {
        const abstractControl = group.get(key);

        this.formErrors[key] = '';
        if (abstractControl && !abstractControl.valid &&
          (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];

          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }

        if (abstractControl instanceof FormGroup) {
          this.logValidationErrors(abstractControl);
        }
    });
  }


    private markFormGroupTouched = (group = this.employeeForm) => {
        (Object as any).values(group.controls).forEach(control => {
            control.markAsTouched();
            if (control.controls) {
                this.markFormGroupTouched(control);
            }
        });
    }

    scrollTop() {
        if (window.scrollY) {
            window.scroll(0, 0);
        }
    }

    back() {
        this.scrollTop();
        this.activePage = this.activePage - 1;
    }

    firstStepValidation() {
        this.getFormatedDates();
        if (
            this.employeeForm.get('candidate.firstName').invalid ||
            this.employeeForm.get('candidate.lastName').invalid ||
            this.employeeForm.get('candidate.middleInitial').invalid ||
            this.employeeForm.get('candidate.gender').invalid ||
            this.employeeForm.get('candidate.originalBirthDate').invalid ||
            this.employeeForm.get('candidate.cellPhone').invalid ||
            this.employeeForm.get('candidate.SocialWebsite').invalid ||
            this.employeeForm.get('candidate.email').invalid
        ) {
            this.employeeForm.get('candidate.firstName').markAsTouched();
            this.employeeForm.get('candidate.lastName').markAsTouched();
            this.employeeForm.get('candidate.middleInitial').markAsTouched();
            this.employeeForm.get('candidate.gender').markAsTouched();
            this.employeeForm.get('candidate.originalBirthDate').markAsTouched();
            this.employeeForm.get('candidate.cellPhone').markAsTouched();
            this.employeeForm.get('candidate.SocialWebsite').markAsTouched();
            this.employeeForm.get('candidate.email').markAsTouched();
        } else {
            this.activePage = 2;
        }
        this.scrollTop();

    }

    secondStepValidation() {
        this.getFormatedDates();
        if (
            this.employeeForm.get('candidate.Armenian').invalid ||
            this.employeeForm.get('candidate.Russian').invalid ||
            this.employeeForm.get('candidate.English').invalid ||
            this.employeeForm.controls.education.invalid
        ) {
            this.employeeForm.get('candidate.Armenian').markAsTouched();
            this.employeeForm.get('candidate.Russian').markAsTouched();
            this.employeeForm.get('candidate.English').markAsTouched();
            // @ts-ignore
            (Object as any).values(this.employeeForm.controls.education.controls).forEach(control => {
                control.controls.eduHistSchool.markAsTouched();
                control.controls.eduHistDegree.markAsTouched();
                control.controls.Profession.markAsTouched();
                control.controls.originalEduHistFrom.markAsTouched();
                control.controls.originalEduHistTo.markAsTouched();
            });
        } else {
            this.activePage = 3;
        }
        this.scrollTop();
    }

    thirdStepValidation() {
        this.getFormatedDates();
        if (this.employeeForm.get('candidate.ExpectedSalary').invalid) {
            this.employeeForm.get('candidate.ExpectedSalary').markAsTouched();
        } else {
            this.activePage = 4;
        }
        this.forthStep = true;
        this.scrollTop();
    }

    forthStepValidation() {
        this.forthActive = true;
        this.activePage = 5;
        this.otherLanguages();
        this.getFormatedDates();
        this.scrollTop();
        this.employeeForm.value.candidate = {...this.employeeForm.value.candidate, BusinessDomain: this.interestsArray.join(', ')};
    }

    formatYear(fullDate): any {
        return `${fullDate.getFullYear()}`;
    }

    formatFullDate(fullDate): any {
        // tslint:disable-next-line: max-line-length
        return `${Number(fullDate.getDate()) < 10 ? 0 : ''}${fullDate.getDate()}/${Number(fullDate.getMonth() + 1) < 10 ? 0 : ''}${fullDate.getMonth() + 1}/${fullDate.getFullYear()}`;
    }

    checkIsValidDate(date) {
        return `${date.getFullYear()}`;
    }

    getFormatedDates() {
        // tslint:disable-next-line: max-line-length
        const hasValideBirthDate = !!this.employeeForm.value.candidate.originalBirthDate ? this.checkIsValidDate(this.employeeForm.value.candidate.originalBirthDate) : null;
        if (hasValideBirthDate) {
            const birthDateSplit = this.formatFullDate(this.employeeForm.value.candidate.originalBirthDate).split('/');
            this.employeeForm.value.candidate.birthdate = birthDateSplit[2] + '-' + birthDateSplit[1] + '-' + birthDateSplit[0];
            this.employeeForm.value.candidate.birthDateViewValue = birthDateSplit[0] + '/' + birthDateSplit[1] + '/' + birthDateSplit[2];
        }
        (Object as any).values(this.employeeForm.value.education).forEach(control => {
            const hasValideduHistFromDate = !!control.originalEduHistFrom ? this.checkIsValidDate(control.originalEduHistFrom) : null;
            if (hasValideduHistFromDate) {
                const educatinStartDate = this.formatFullDate(control.originalEduHistFrom).split('/');
                control.eduHistFrom = educatinStartDate[1] + '-' + educatinStartDate[2];
                control.eduHistFromViewValue = educatinStartDate[0] + '/' + educatinStartDate[1] + '/' + educatinStartDate[2];
            }

            const hasValideduHistToDate = !!control.originalEduHistTo ? this.checkIsValidDate(control.originalEduHistTo) : null;
            if (hasValideduHistToDate) {
                const educatinEndDate = this.formatFullDate(control.originalEduHistTo).split('/');
                control.eduHistTo = educatinEndDate[1] + '-' + educatinEndDate[2];
                control.eduHistToViewValue = educatinEndDate[0] + '/' + educatinEndDate[1] + '/' + educatinEndDate[2];
            } else if(control.eduCheckbox) {
                control.eduHistTo = 'To Present';
            }
        });
        (Object as any).values(this.employeeForm.value.certificate).forEach(control => {
            const hasValidYearProvidedDate = !!control.originalYearProvided ? this.checkIsValidDate(control.originalYearProvided) : null;
            if (hasValidYearProvidedDate) {
                const certYear = this.formatFullDate(control.originalYearProvided).split('/');
                control.YearProvided = certYear[2] + '-' + certYear[1] + '-' + certYear[0];
                control.yearProvidedViewValue = certYear[0] + '/' + certYear[1] + '/' + certYear[2];
                this.showCertificate = true;
            }
        });
        (Object as any).values(this.employeeForm.value.workhistory).forEach(control => {
            const hasValidworkHistFromDate = !!control.originalWorkHistFrom ? this.checkIsValidDate(control.originalWorkHistFrom) : null;
            if (hasValidworkHistFromDate) {
                const workEndDate = this.formatFullDate(control.originalWorkHistFrom).split('/');
                control.workHistFrom = workEndDate[1] + '-' + workEndDate[2];
                control.workHistFromViewValue = workEndDate[0] + '/' + workEndDate[1] + '/' + workEndDate[2];
                this.showWorkHistory = true;
            }

            const hasValidworkHistToDate = !!control.originalWorkHistTo ? this.checkIsValidDate(control.originalWorkHistTo) : null;
            if (hasValidworkHistToDate) {
                const workStartDate = this.formatFullDate(control.originalWorkHistTo).split('/');
                control.workHistTo = workStartDate[1] + '-' + workStartDate[2];
                control.workHistToViewValue = workStartDate[0] + '/' + workStartDate[1] + '/' + workStartDate[2];
            } else if (control.workCheckbox) {
                control.workHistTo = 'To Present';
            }
        });
    }

    getPageUpdateDate() {
        this.firstStageService.getPageUpdateDate(this.updateId).subscribe((result) => {
          if (result) {
            const originalDate = result;
            // @ts-ignore
            const originalDateSplit = originalDate.split('T');
            const originalDay = originalDateSplit[0].split('-');
            const originalHours = originalDateSplit[1].split(':');
            const dayToView = originalDay[2] + '/' + originalDay[1] + '/' + originalDay[0];
            const hoursToview = originalHours[0] + ':' + originalHours[1];
            this.updateDate = dayToView + ',' + ' ' + hoursToview;
          }
        });
    }

    onSubmit() {
        console.log(this.employeeForm.value);
    }

}

